import { ID } from '../../utils/codecUtils';
import { engineFieldSchema } from '../models/engineField.schema';

export const get = (engineFieldId: ID) => {
  return {
    endpoint: `/engine_fields/${engineFieldId}`,
    method: 'GET',
    responseSchema: engineFieldSchema,
  } as const;
};
